import { render, staticRenderFns } from "./PortfolioPrivacyTag.vue?vue&type=template&id=3848f738"
import script from "./PortfolioPrivacyTag.vue?vue&type=script&lang=js"
export * from "./PortfolioPrivacyTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports